// extracted by mini-css-extract-plugin
export default {"price":"z8-z","priceRow":"A8-z","onSale":"B8-z","msrpLabelPrice":"C8-z","msrpLabel":"D8-z","originalPrice":"E8-z","percentOff":"F8-z"};